
import React from "react";
import MainLayout from "@/components/layout/MainLayout";
import FloatingAnimations from "@/components/home/FloatingAnimations";
import PromoBar from "@/components/home/PromoBar";
import HeroSection from "@/components/home/HeroSection";
import FeaturesGrid from "@/components/home/FeaturesGrid";

const Index = () => {
  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-b from-white to-madts-gray overflow-hidden">
        {/* Floating Animation Elements */}
        <FloatingAnimations />

        {/* Promotional Banner */}
        <PromoBar />

        {/* Hero Section */}
        <HeroSection />

        {/* Features Grid */}
        <FeaturesGrid />
      </div>
    </MainLayout>
  );
};

export default Index;
